import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { MIN_STATUS, RESULT_NAME } from '../../../../../shared/utils/constants';
import { ErrorModelData } from '../../../../../vass-core/interfaces/error-model-data.interface';
import { DashboardSectionService } from '../../../../services/dashboard-section/dashboard-section.service';
import { YourMortgageSectionModel } from './../../../../models/your-mortgage-section.model';

import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-your-mortgage',
  templateUrl: './your-mortgage.component.html',
  styleUrls: ['./your-mortgage.component.scss'],
  standalone: false,
})
export class YourMortgageComponent implements OnInit, OnChanges {
  @Input() simulateResult: any;
  @Input() status: number;
  @Input() formatTable: boolean = false;
  @Input() isRejected: boolean = false;

  public RESULT_NAME = RESULT_NAME;
  public httpError = false;
  public collapseMortgage = true;
  public error: ErrorModelData;
  public yourMortgage: YourMortgageSectionModel;
  public substatus: number;
  public minStatus = MIN_STATUS;

  constructor(
    private dashboardSectionService: DashboardSectionService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.updateMortgageSectionData();
    this.router.events.pipe(distinctUntilChanged()).subscribe((event: any) => {
      if (event.url !== '/dashboard') {
        this.collapseMortgage = true;
      } else {
        this.collapseMortgage = false;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.status) {
      this.getYourMortgageSectionData();
      this.getStatuses();
    }
  }

  private updateMortgageSectionData() {
    this.dashboardSectionService.getUpdateMortgageSectionData().subscribe((response) => {
      this.getYourMortgageSectionData();
    });
  }

  private getYourMortgageSectionData() {
    if (this.status >= MIN_STATUS.simulation_done) {
      this.dashboardSectionService.getYourMortgageSectionData().subscribe(
        (response) => {
          this.yourMortgage = response;
          this.yourMortgage.tae = parseFloat(this.yourMortgage.tae.toFixed(2));
        },
        (error) => (this.httpError = true),
      );
    }
  }

  private getStatuses() {
    const statusBefore = this.status;
    if (!this.formatTable && statusBefore && statusBefore.toString().indexOf('.') > 0) {
      this.status = parseFloat(statusBefore.toString().split('.')[0]);
      this.substatus = parseFloat(statusBefore.toString().split('.')[1]);
    }
  }
}
